module.exports = __webpack_public_path__ + "img/avatar-s-20.084305f8.jpg";